import styled from "styled-components";

const ThreeColumns = styled.div`
  column-count: 3;
`;

export default ThreeColumns;
